import './styles/DayStreakCard.css';

interface DayStreakCardProps {
  streak: number;
}

const DayStreakCard: React.FC<DayStreakCardProps> = ({ streak }) => (
  <div className="streak-card">
    <span className="streak-card__icon">🔥</span>
    <div>
      <div className="streak-card__value">{0}</div>
      <div className="streak-card__label">Day Streak!</div>
      {/* <div className="streak-card__sub">Keep it up 🚀</div> */}
    </div>
  </div>
);

export default DayStreakCard;
